




import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingErrorStatus} from '@/enums/status/ladingerror';
import {IdMapper} from "@/interfaces/state/base";
    @Component({
        name: "LadingErrorStatusLabel"
    })
    export default class extends Vue {
        @Prop({ required: true})
        readonly status!: number;
        LadingErrorStatus = LadingErrorStatus
        colorMap: IdMapper<string> = {
            [LadingErrorStatus.ChoXuLy]: 'red',
            [LadingErrorStatus.DaXuLy]: 'green'
        }
    }
